var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-engine-optimization_11657413 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M66.6693 47.1652H58.2526C60.3478 43.8911 61.5235 40.1135 61.6566 36.2286C61.7896 32.3437 60.8751 28.4946 59.0088 25.0847C57.1426 21.6748 54.3934 18.8298 51.0494 16.8479C47.7054 14.8661 43.8898 13.8203 40.0026 13.8203C36.1154 13.8203 32.2998 14.8661 28.9559 16.8479C25.6119 18.8298 22.8626 21.6748 20.9964 25.0847C19.1301 28.4946 18.2156 32.3437 18.3486 36.2286C18.4817 40.1135 19.6574 43.8911 21.7526 47.1652H13.3359C10.6838 47.1652 8.14023 48.2188 6.26487 50.0942C4.38951 51.9695 3.33594 54.5131 3.33594 57.1652C3.33594 59.8174 4.38951 62.361 6.26487 64.2363C8.14023 66.1117 10.6838 67.1652 13.3359 67.1652H66.6693C69.3214 67.1652 71.865 66.1117 73.7403 64.2363C75.6157 62.361 76.6693 59.8174 76.6693 57.1652C76.6693 54.5131 75.6157 51.9695 73.7403 50.0942C71.865 48.2188 69.3214 47.1652 66.6693 47.1652ZM21.6693 35.4986C21.6741 32.5607 22.3848 29.6669 23.7417 27.0611C25.0986 24.4553 27.0618 22.2138 29.4661 20.5253C31.8703 18.8368 34.6451 17.7509 37.5568 17.359C40.4684 16.967 43.4316 17.2806 46.1968 18.2732C48.9619 19.2658 51.448 20.9084 53.4457 23.0627C55.4433 25.2169 56.8939 27.8197 57.6754 30.6517C58.4569 33.4838 58.5463 36.4622 57.9361 39.3361C57.326 42.2099 56.0341 44.895 54.1693 47.1652H25.8776C23.1621 43.8833 21.6741 39.7583 21.6693 35.4986ZM6.66927 57.1652C6.66927 55.3971 7.37165 53.7014 8.62189 52.4512C9.87213 51.201 11.5678 50.4986 13.3359 50.4986H53.3359V63.8319H13.3359C11.5678 63.8319 9.87213 63.1295 8.62189 61.8793C7.37165 60.629 6.66927 58.9334 6.66927 57.1652ZM66.6693 63.8319H56.6693V50.4986H66.6693C68.4374 50.4986 70.1331 51.201 71.3833 52.4512C72.6336 53.7014 73.3359 55.3971 73.3359 57.1652C73.3359 58.9334 72.6336 60.629 71.3833 61.8793C70.1331 63.1295 68.4374 63.8319 66.6693 63.8319Z",
    fill: "url(#paint0_linear_1449_12698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0026 51.332C14.5606 51.332 14.1367 51.5076 13.8241 51.8202C13.5115 52.1327 13.3359 52.5567 13.3359 52.9987V61.332C13.3359 61.7741 13.5115 62.198 13.8241 62.5105C14.1367 62.8231 14.5606 62.9987 15.0026 62.9987C15.4446 62.9987 15.8686 62.8231 16.1811 62.5105C16.4937 62.198 16.6693 61.7741 16.6693 61.332V52.9987C16.6693 52.5567 16.4937 52.1327 16.1811 51.8202C15.8686 51.5076 15.4446 51.332 15.0026 51.332Z",
    fill: "url(#paint1_linear_1449_12698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M67.8477 57.6853C68.1365 56.9705 68.2262 56.1908 68.1073 55.4291C67.9884 54.6673 67.6654 53.9521 67.1725 53.3592C66.6796 52.7664 66.0353 52.3182 65.3081 52.0623C64.5809 51.8064 63.7979 51.7522 63.0424 51.9057C62.2869 52.0591 61.5871 52.4144 61.0173 52.9338C60.4476 53.4531 60.0292 54.1172 59.8066 54.8553C59.5841 55.5934 59.5657 56.378 59.7534 57.1258C59.9411 57.8735 60.3279 58.5564 60.8727 59.1019C61.4701 59.6891 62.2249 60.0906 63.0457 60.2577C63.8665 60.4248 64.7182 60.3505 65.4977 60.0436L66.7643 61.3353C66.9198 61.4966 67.1062 61.6249 67.3124 61.7125C67.5186 61.8002 67.7403 61.8453 67.9643 61.8453C68.1884 61.8453 68.4101 61.8002 68.6163 61.7125C68.8225 61.6249 69.0089 61.4966 69.1643 61.3353C69.4747 61.023 69.649 60.6006 69.649 60.1603C69.649 59.72 69.4747 59.2976 69.1643 58.9853L67.8477 57.6853ZM63.231 56.7519C63.0717 56.5728 62.9868 56.3397 62.9935 56.1001C63.0001 55.8606 63.0979 55.6325 63.2668 55.4625C63.4358 55.2925 63.6632 55.1933 63.9027 55.1852C64.1422 55.177 64.3759 55.2605 64.556 55.4186C64.7152 55.5977 64.8002 55.8308 64.7935 56.0704C64.7869 56.31 64.6891 56.538 64.5202 56.708C64.3512 56.878 64.1238 56.9772 63.8843 56.9854C63.6447 56.9935 63.4111 56.9101 63.231 56.7519Z",
    fill: "url(#paint2_linear_1449_12698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.1776 60.1747L24.8359 58.8331L26.0109 57.6581L19.5859 55.9414L21.3026 62.3581L22.5026 61.1831L23.8526 62.5331C25.3359 64.0414 27.7109 61.6997 26.1776 60.1747Z",
    fill: "url(#paint3_linear_1449_12698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M46.4325 31.4318L42.4992 35.3401H33.7742C33.5543 35.3399 33.3365 35.3833 33.1334 35.4677C32.9303 35.5521 32.7459 35.6758 32.5909 35.8318L26.1242 42.2984C25.8103 42.6112 25.6336 43.0358 25.6328 43.4788C25.632 43.9219 25.8073 44.3471 26.12 44.6609C26.4328 44.9748 26.8574 45.1515 27.3004 45.1523C27.7435 45.1531 28.1687 44.9778 28.4825 44.6651L34.4575 38.6818H43.2075C43.6476 38.6821 44.07 38.5084 44.3825 38.1984L48.7909 33.7901L50.5492 35.5568L52.6992 27.5234L44.6742 29.6651L46.4325 31.4318Z",
    fill: "url(#paint4_linear_1449_12698)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M66.6693 47.1652H58.2526C60.3478 43.8911 61.5235 40.1135 61.6566 36.2286C61.7896 32.3437 60.8751 28.4946 59.0088 25.0847C57.1426 21.6748 54.3934 18.8298 51.0494 16.8479C47.7054 14.8661 43.8898 13.8203 40.0026 13.8203C36.1154 13.8203 32.2998 14.8661 28.9559 16.8479C25.6119 18.8298 22.8626 21.6748 20.9964 25.0847C19.1301 28.4946 18.2156 32.3437 18.3486 36.2286C18.4817 40.1135 19.6574 43.8911 21.7526 47.1652H13.3359C10.6838 47.1652 8.14023 48.2188 6.26487 50.0942C4.38951 51.9695 3.33594 54.5131 3.33594 57.1652C3.33594 59.8174 4.38951 62.361 6.26487 64.2363C8.14023 66.1117 10.6838 67.1652 13.3359 67.1652H66.6693C69.3214 67.1652 71.865 66.1117 73.7403 64.2363C75.6157 62.361 76.6693 59.8174 76.6693 57.1652C76.6693 54.5131 75.6157 51.9695 73.7403 50.0942C71.865 48.2188 69.3214 47.1652 66.6693 47.1652ZM21.6693 35.4986C21.6741 32.5607 22.3848 29.6669 23.7417 27.0611C25.0986 24.4553 27.0618 22.2138 29.4661 20.5253C31.8703 18.8368 34.6451 17.7509 37.5568 17.359C40.4684 16.967 43.4316 17.2806 46.1968 18.2732C48.9619 19.2658 51.448 20.9084 53.4457 23.0627C55.4433 25.2169 56.8939 27.8197 57.6754 30.6517C58.4569 33.4838 58.5463 36.4622 57.9361 39.3361C57.326 42.2099 56.0341 44.895 54.1693 47.1652H25.8776C23.1621 43.8833 21.6741 39.7583 21.6693 35.4986ZM6.66927 57.1652C6.66927 55.3971 7.37165 53.7014 8.62189 52.4512C9.87213 51.201 11.5678 50.4986 13.3359 50.4986H53.3359V63.8319H13.3359C11.5678 63.8319 9.87213 63.1295 8.62189 61.8793C7.37165 60.629 6.66927 58.9334 6.66927 57.1652ZM66.6693 63.8319H56.6693V50.4986H66.6693C68.4374 50.4986 70.1331 51.201 71.3833 52.4512C72.6336 53.7014 73.3359 55.3971 73.3359 57.1652C73.3359 58.9334 72.6336 60.629 71.3833 61.8793C70.1331 63.1295 68.4374 63.8319 66.6693 63.8319Z",
    fill: "url(#paint5_linear_1449_12698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.0026 51.332C14.5606 51.332 14.1367 51.5076 13.8241 51.8202C13.5115 52.1327 13.3359 52.5567 13.3359 52.9987V61.332C13.3359 61.7741 13.5115 62.198 13.8241 62.5105C14.1367 62.8231 14.5606 62.9987 15.0026 62.9987C15.4446 62.9987 15.8686 62.8231 16.1811 62.5105C16.4937 62.198 16.6693 61.7741 16.6693 61.332V52.9987C16.6693 52.5567 16.4937 52.1327 16.1811 51.8202C15.8686 51.5076 15.4446 51.332 15.0026 51.332Z",
    fill: "url(#paint6_linear_1449_12698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M67.8555 57.6814C68.1443 56.9666 68.234 56.1869 68.1151 55.4252C67.9962 54.6634 67.6732 53.9482 67.1803 53.3553C66.6874 52.7625 66.0432 52.3143 65.3159 52.0584C64.5887 51.8025 63.8057 51.7483 63.0502 51.9018C62.2947 52.0552 61.5949 52.4105 61.0251 52.9299C60.4554 53.4492 60.037 54.1133 59.8145 54.8514C59.5919 55.5895 59.5735 56.3741 59.7612 57.1219C59.9489 57.8696 60.3357 58.5525 60.8805 59.098C61.4779 59.6852 62.2327 60.0867 63.0535 60.2538C63.8744 60.4209 64.726 60.3466 65.5055 60.0397L66.7721 61.3314C66.9276 61.4927 67.114 61.621 67.3202 61.7086C67.5264 61.7963 67.7481 61.8414 67.9721 61.8414C68.1962 61.8414 68.4179 61.7963 68.6241 61.7086C68.8303 61.621 69.0167 61.4927 69.1721 61.3314C69.4826 61.0191 69.6568 60.5967 69.6568 60.1564C69.6568 59.7161 69.4826 59.2936 69.1721 58.9814L67.8555 57.6814ZM63.2388 56.748C63.0796 56.5689 62.9946 56.3358 63.0013 56.0962C63.0079 55.8567 63.1057 55.6286 63.2746 55.4586C63.4436 55.2886 63.671 55.1894 63.9105 55.1813C64.1501 55.1731 64.3837 55.2566 64.5638 55.4147C64.723 55.5938 64.808 55.8269 64.8013 56.0665C64.7947 56.3061 64.6969 56.5341 64.528 56.7041C64.359 56.8741 64.1316 56.9733 63.8921 56.9815C63.6526 56.9896 63.4189 56.9062 63.2388 56.748Z",
    fill: "url(#paint7_linear_1449_12698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.1776 60.1747L24.8359 58.8331L26.0109 57.6581L19.5859 55.9414L21.3026 62.3581L22.5026 61.1831L23.8526 62.5331C25.3359 64.0414 27.7109 61.6997 26.1776 60.1747Z",
    fill: "url(#paint8_linear_1449_12698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M46.4325 31.4318L42.4992 35.3401H33.7742C33.5543 35.3399 33.3365 35.3833 33.1334 35.4677C32.9303 35.5521 32.7459 35.6758 32.5909 35.8318L26.1242 42.2984C25.8103 42.6112 25.6336 43.0358 25.6328 43.4788C25.632 43.9219 25.8073 44.3471 26.12 44.6609C26.4328 44.9748 26.8574 45.1515 27.3004 45.1523C27.7435 45.1531 28.1687 44.9778 28.4825 44.6651L34.4575 38.6818H43.2075C43.6476 38.6821 44.07 38.5084 44.3825 38.1984L48.7909 33.7901L50.5492 35.5568L52.6992 27.5234L44.6742 29.6651L46.4325 31.4318Z",
    fill: "url(#paint9_linear_1449_12698)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1449_12698",
    x1: 3.33594,
    y1: 40.4986,
    x2: 76.6693,
    y2: 40.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1449_12698",
    x1: 13.3359,
    y1: 57.1904,
    x2: 16.6693,
    y2: 57.1904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F749FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D96FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1449_12698",
    x1: 59.6227,
    y1: 56.8019,
    x2: 69.6143,
    y2: 56.8019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F749FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D96FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1449_12698",
    x1: 19.5859,
    y1: 59.4831,
    x2: 26.6776,
    y2: 59.4831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F749FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D96FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1449_12698",
    x1: 25.6325,
    y1: 36.3318,
    x2: 52.6992,
    y2: 36.3318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F749FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D96FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1449_12698",
    x1: 3.33594,
    y1: 40.4986,
    x2: 76.6693,
    y2: 40.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1449_12698",
    x1: 3.33594,
    y1: 40.4987,
    x2: 76.6693,
    y2: 40.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEA49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1449_12698",
    x1: 3.33879,
    y1: 40.498,
    x2: 76.6721,
    y2: 40.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1449_12698",
    x1: 3.33594,
    y1: 40.4997,
    x2: 76.6693,
    y2: 40.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B08C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1449_12698",
    x1: 3.33252,
    y1: 40.4984,
    x2: 76.6659,
    y2: 40.4984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEA49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ddf4b9531b96e978edc9677eea14b6f0.svg";
export { ForwardRef as ReactComponent };